export const paintings = [
	{
		"id": 1,
		"jump": "fragment",
		"title": "Fragment",
		"pic": "../img/paintings/fragment.jpg",
		"size": "24x30 in.",
		"desc": "Oil & Acrylic on Canvas",
		"year": "2017",
		"alt": "Fragment, Acrylic and Oil Painting",
		"left": "image",
		"right": "reg",
		"orientation": "work"
	},
	{
		"id": 2,
		"jump": "connected",
		"title": "Connected",
		"pic": "../img/paintings/connected.jpg",
		"size": "24x30 in.",
		"desc": "Oil & Acrylic on Canvas",
		"year": "2017",
		"alt": "Connected, Acrylic and Oil Painting",
		"left": "image",
		"right": "reg",
		"orientation": "work"
	},
	{
		"id": 3,
		"jump": "magicfades",
		"title": "The Magic Fades",
		"pic": "../img/paintings/the-magic-fades.jpg",
		"size": "48x36 in.",
		"desc": "Oil & Acrylic on Canvas",
		"year": "2018",
		"alt": "The Magic Fades, Acrylic and Oil Painting",
		"left": "imagewider",
		"right": "slimmer",
		"orientation": "landscape"
	},
	{
		"id": 4,
		"jump": "giants",
		"title": "Among Giants II",
		"pic": "../img/paintings/among-giants-ii.jpg",
		"size": "24x36 in.",
		"desc": "Oil & Acrylic on Canvas",
		"year": "2016",
		"alt": "Among Giants 2, ACrylic and Oil Painting",
		"left": "image",
		"right": "reg",
		"orientation": "work"
	},
	{
		"id": 5,
		"jump": "zodiak",
		"title": "Zodiak",
		"pic": "../img/paintings/zodiak.jpg",
		"size": "12x16 in.",
		"desc": "Watercolor, Gouache, India Ink on Cold-Press Arches Watercolor Paper",
		"year": "2021",
		"alt": "Zodiak, Watercolor and Gouache Painting",
		"left": "image",
		"right": "reg",
		"orientation": "work"
	},
	{
		"id": 6,
		"jump": "puddle",
		"title": "Puddle",
		"pic": "../img/paintings/puddle.jpg",
		"size": "16x12 in.",
		"desc": "India Ink & Gouache on Cold-Press Arches Watercolor Paper",
		"year": "2020",
		"alt": "Puddle, India Ink and Gouache Painting",
		"left": "imagewider shadow",
		"right": "slimmer",
		"orientation": "landscape"
	},
	{
		"id": 7,
		"jump": "stoughton",
		"title": "Evening at Stoughton Pond",
		"pic": "../img/paintings/stoughton-pond.jpg",
		"size": "40x16 in.",
		"desc": "Oil & Acrylic on Canvas",
		"year": "2016",
		"alt": "Evening at Stoughton Pond, Acrylic and Oil Painting",
		"left": "imagewider",
		"right": "slimmer",
		"orientation": "landscape"
	},
	{
		"id": 8,
		"jump": "time",
		"title": "Time As a Circle",
		"pic": "../img/paintings/time-as-a-circle.jpg",
		"size": "36x36 in.",
		"desc": "Oil & Acrylic on Canvas",
		"year": "2014",
		"alt": "Time as a Circle, Acrylic and Oil Painting",
		"left": "imagewide",
		"right": "slim",
		"orientation": "work"
	},
	{
		"id": 9,
		"jump": "robinmoth",
		"title": "Robin Moth",
		"pic": "../img/paintings/robin-moth.jpg",
		"size": "28x22 in.",
		"desc": "Oil & Acrylic on Canvas",
		"year": "2016",
		"alt": "Robin Moth, Acrylic and Oil Painting",
		"left": "imagewider",
		"right": "slimmer",
		"orientation": "landscape"
	},
]	